import React from 'react';
import axios from 'axios';
import { Sidebar } from '../../components/Sidebar';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API_URL}/api/agency-plans`;
const cfg = { withCredentials: true };

export const plansApi = {
  get: (p = '', params) => axios.get(`${BASE}${p}`, { ...cfg, params }).then((r) => r.data),
  post: (p, b = {}) => axios.post(`${BASE}${p}`, b, cfg).then((r) => r.data),
  put: (p, b) => axios.put(`${BASE}${p}`, b, cfg).then((r) => r.data),
  upload: (p, file) => { const fd = new FormData(); fd.append('file', file); return axios.post(`${BASE}${p}`, fd, cfg).then((r) => r.data); },
  blob: (p) => axios.get(`${BASE}${p}`, { ...cfg, responseType: 'blob' }).then((r) => r.data),
};

export const downloadBlob = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const errMsg = (e, f) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : f);
export const inr = (n) => `₹${Math.round(n || 0).toLocaleString('en-IN')}`;
export const compact = (n) => (!n ? '—' : n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${(n / 1e3).toFixed(n >= 1e5 ? 0 : 1)}K` : String(n));
export const dateShort = (iso) => (iso ? new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');
export const dateTime = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');

export const FIELD = 'w-full h-9 rounded-md px-3 text-sm bg-white dark:bg-[#1A1D24] border border-black/[0.12] dark:border-white/[0.08] text-[#0F0F0F] dark:text-white placeholder-[#A1A1AA] focus:outline-none focus:border-[#FF451A]/60 transition-colors';
export const LABEL = 'text-xs font-semibold uppercase tracking-[0.08em] block mb-2 text-[#0F0F0F] dark:text-white';
const BTN = 'rounded-full px-4 py-2 text-xs font-semibold inline-flex items-center gap-1.5 disabled:opacity-40 transition-colors';
export const PRIMARY = `${BTN} bg-[#FF451A] hover:bg-[#E63E17] text-white`;
export const GHOST = `${BTN} border border-black/[0.12] dark:border-white/[0.08] text-[#0F0F0F] dark:text-white hover:border-[#FF451A]/50 hover:text-[#FF451A]`;
export const CARD = 'bg-white dark:bg-[#111318] border border-black/[0.07] dark:border-white/[0.06] rounded-2xl';

export const STATUS = {
  draft: { label: 'Draft', cls: 'bg-black/[0.05] text-[#4B5563] dark:bg-white/10 dark:text-zinc-300' },
  under_review: { label: 'Under Review', cls: 'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300' },
  changes_requested: { label: 'Changes Requested', cls: 'bg-[#FF451A]/10 text-[#C2410C] dark:text-[#FF8A5B]' },
  approved: { label: 'Approved', cls: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300' },
};

export const StatusBadge = ({ status, testid }) => {
  const s = STATUS[status] || STATUS.draft;
  return <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ${s.cls}`} data-testid={testid}>{s.label}</span>;
};

export const PageShell = ({ testid, children }) => (
  <div className="flex min-h-screen">
    <Sidebar />
    <div className="flex-1 p-8 bg-white dark:bg-[#0A0B0D] min-w-0" data-testid={testid}>
      <div className="max-w-[1200px] mx-auto space-y-6">{children}</div>
    </div>
  </div>
);

export const PageHeader = ({ icon: Icon, title, sub, action }) => (
  <div className="flex items-end justify-between gap-4 flex-wrap">
    <div>
      <h1 className="text-4xl font-bold tracking-tight text-[#0F0F0F] dark:text-white mb-2 flex items-center gap-3">{Icon && <Icon className="text-[#FF451A]" size={30} />} {title}</h1>
      {sub && <p className="text-[#6B6B6B] dark:text-zinc-400">{sub}</p>}
    </div>
    {action}
  </div>
);
